import { addDoc, collection, doc, getDoc, onSnapshot, orderBy, query, setDoc } from "firebase/firestore";
import { useEffect, useState, useRef, useContext } from "react";
import { db } from "../../firebase/firebase";
import { format, isToday } from 'date-fns';
import { showTost } from "../../showTost";
import axios from "axios";
import { MyContext } from "../../Context/MyProvider";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import Loading from "../../Loading";
import { IoChevronBackOutline } from "react-icons/io5";
const Chat = ({ index, name, id, setShowChat }) => {

    const { t } = useTranslation();

    const { OneSingalAppidOR, OneSingalKeyOR } = useContext(MyContext);

    const [chatRoom, setChatRoom] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    const [selectUserid, setSelectUserid] = useState("");
    const [selectUser, setSelectUser] = useState("");
    const [allChat, setAllChat] = useState([]);
    const [input, setInput] = useState("");

    const Userid = localStorage.getItem("Userid");

    const chatBoxBodyRef = useRef(null);
    const IndexRef = useRef(false);

    useEffect(() => {
        fetchMyUserChat();
    }, []);

    const fetchMyUserChat = async () => {
        setLoading(true);

        try {
            const usersCollection = collection(db, "Magic_Organization_rooms");

            const unsubscribe = onSnapshot(usersCollection, (snapshot) => {
                const users = [];
                for (const doc of snapshot.docs) {
                    const userData = doc.id;
                    const [id1, id2] = userData.split("_");
                    const otherId = id1 === Userid ? id2 : id2 === Userid ? id1 : null;
                    if (otherId) users.push(otherId);

                }
                setChatRoom(users);
                setLoading(false);
            });

            return () => unsubscribe();

        } catch (error) {
            console.error("Error fetching document:", error);
        }
    };

    useEffect(() => {
        const userCollection = collection(db, "MagicOrganizer");

        const unsubscribe = onSnapshot(userCollection, (snapshot) => {
            const userData = [];

            snapshot.forEach((doc) => {
                userData.push({
                    id: doc.id,
                    ...doc.data()
                });
            });

            const filterUser = userData.filter((item) => chatRoom?.includes(item?.id));
            setUserList(filterUser);

            if (window.innerWidth > 770) {
                if (!selectUserid && !IndexRef.current && filterUser.length > 0) {
                    setSelectUserid(filterUser[0].id);
                    setSelectUser(filterUser[0]);
                    IndexRef.current = true;
                }
            }
        });

        return () => unsubscribe();

    }, [chatRoom]);

    useEffect(() => {
        if (id && userList.length > 0) {
            const selected = userList.find(user => user.id === id);
            if (selected) {
                setSelectUserid(id);
                setSelectUser(selected);
            }
        }
    }, [id, userList]);

    useEffect(() => {
        let unsubscribe;
        if (Userid && selectUserid) {
            unsubscribe = HandleGetChat();
        }
        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [selectUserid]);

    useEffect(() => {
        setSelectUserid(id);
    }, [id]);

    const HandleGetChat = () => {

        const chatRoomId = [Userid, selectUserid].join("_");

        const messagesRef = collection(db, "Magic_Organization_rooms", chatRoomId, "messages");

        const messagesQuery = query(messagesRef, orderBy("sentTime", "asc"));

        const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
            const chats = [];
            snapshot.forEach((doc) => {
                const data = doc.data();
                const Id = data.senderId === Userid ? data.receiverId : data.senderId;
                if (Id === selectUserid || data.senderId === selectUserid) {
                    chats.push(data);
                }
            });
            setAllChat(chats);
        });
        return unsubscribe;
    };

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp.seconds * 1000);

        if (isToday(date)) {
            return `Today ${format(date, 'hh:mm a')}`;
        } else {
            return format(date, 'dd MMM yyyy hh:mm a');
        }
    };

    const HandleSendMessage = async () => {
        if (!selectUserid) {
            showTost(t("Please Select User !!"), "error");
            return;
        }

        if (!input) {
            showTost(t("Please Write Message !!"), "error");
            return;
        }

        const ChatID = [Userid, selectUserid].join("_");
        const chatRoomRef1 = doc(db, 'Magic_Organization_rooms', ChatID);
        const docSnapshot1 = await getDoc(chatRoomRef1);

        if (!docSnapshot1.exists()) {
            setDoc(chatRoomRef1, {
                timestamp: new Date(),
            });
        }


        const messagesCollectionRef = collection(chatRoomRef1, "messages");

        const messageData = {
            content: input,
            messageType: 'text',
            senderId: Userid,
            receiverId: selectUserid,
            sentTime: new Date(),
        };

        addDoc(messagesCollectionRef, messageData)
            .then((docRef) => {
                setInput('');
                NotificationSend(input, selectUserid);
            })
            .catch((error) => {
                console.error("Error adding message:", error);
            });
    }

    useEffect(() => {
        if (chatBoxBodyRef.current) {
            chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
        }
    }, [allChat]);

    const NotificationSend = async (message, RiceiverId) => {

        const LoginData = localStorage.getItem("LoginData");

        if (Notification.permission === "granted" && LoginData) {

            const { name } = JSON.parse(LoginData);

            try {
                await axios.post('https://onesignal.com/api/v1/notifications', {
                    app_id: OneSingalAppidOR,
                    filters: [
                        { field: 'tag', key: 'orag_id', value: RiceiverId }
                    ],
                    headings: {
                        en: name
                    },
                    contents: {
                        en: message,
                    },
                }, {
                    headers: {
                        Authorization: OneSingalKeyOR,
                    },
                })
                    .then((res) => {
                        console.log("Notification Send Success !!", res);
                    })
                    .catch((error) => {
                        console.error("Notification Error", error);
                    });
            } catch (error) {
            }
        }
    }

    const HandleKeyDown = (e) => {
        if (e.key === "Enter") {

            if (!selectUserid) {
                showTost(t("Please Select User !!"), "error");
                return;
            }

            if (!input) {
                showTost(t("Please Write Message !!"), "error");
                return;
            }

            HandleSendMessage();
        }
    }

    return (
        <div className={index !== 0 && "width_container"}>
            <div className="chat_box">
                {index === 0
                    ? <div className="border-[2px] rounded-[10px]">
                        <div className="py-[8px] px-[10px] flex items-center gap-[10px]">
                            <button onClick={() => setShowChat(false)} className="text-[20px]"><FaArrowLeftLong /></button>
                            <div className="name_box">{name.slice(0, 1)}</div>
                            <h1>{name}</h1>
                        </div>
                        <div ref={chatBoxBodyRef} className="h-[450px] scroll-container px-[15px] flex border-t-[2px] py-[5px]">
                            <ul className="w-[100%]">
                                {allChat.map((item, index) => {
                                    return <li key={index} className={`${item.senderId === Userid ? "msg_out" : "msg_in"} mt-[15px]`}>
                                        <div style={{ textAlign: item?.senderId === Userid ? "end" : "start" }}>
                                            <span className="msg_text">{item?.content}</span>
                                            <div className="text-[11px] mt-[8px] text-gray-500">{formatTimestamp(item.sentTime)}</div>
                                        </div>
                                    </li>
                                })}
                            </ul>
                        </div>
                        <div className="bg-white p-[15px] rounded-[10px] border-t-[2px]">
                            <div className="flex items-center gap-[10px]">
                                <input type="text" value={input} onKeyDown={HandleKeyDown} onChange={(e) => setInput(e.target.value)} className="w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400" placeholder={t("Add Message...")} />
                                <button onClick={HandleSendMessage} className="send_btn">{t("Send")}</button>
                            </div>
                        </div>
                    </div>
                    : <div className="main_box mt-[20px] max-_430_:mt-[5px]">
                        
                        <div className={`user_box ${selectUserid && "user_box_hidden"} bg-white`}>
                            <div className="flex items-center">
                                <input className="w-[100%] border-[1px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] focus-within:outline-[#4038FF]" placeholder={t("Search...")} type="text" />
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" className="-ms-[27px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="none" stroke-miterlimit="10" stroke-width="32" d="M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64z"></path>
                                    <path fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M338.29 338.29 448 448"></path>
                                </svg>
                            </div>
                            <div className="mt-[10px] h-[100%] pb-[47px] scroll-container">
                                {userList.map((item, index) => {
                                    return <div key={index} onClick={() => { setSelectUserid(item.id); setSelectUser(item) }} className={`${selectUserid === item.id && "bg-[#f1f2f4]"} hover:bg-[#f1f2f4] px-[10px] py-[10px] rounded-[15px] cursor-pointer mt-[10px]`}>
                                        <div className="flex items-center gap-[15px]">
                                            <div className="name_box">{item.name.slice(0, 1)}</div>
                                            <h1 className="font-bold text-[18px]">{item.name}</h1>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>

                        <div className={`user_chat ${selectUserid && "user_chat_show"}`}>

                            <div className="bg-white p-[10px] rounded-[10px]">
                                {selectUser
                                    ? <div className="flex items-center gap-[15px]">
                                        <button onClick={() => { setSelectUserid(""); setSelectUser("") }} className="text-[20px] hidden max-_770_:block"><IoChevronBackOutline /></button>
                                        <div className="name_box">{selectUser?.name.slice(0, 1)}</div>
                                        <h1 className="font-bold text-[18px]">{selectUser?.name}</h1>
                                    </div>
                                    : <h1 className="font-bold text-[18px] py-[10px]">{t("Select User")}</h1>}
                            </div>

                            <div ref={chatBoxBodyRef} className="h-[100%] scroll-container px-[15px] flex">
                                <ul className="py-[15px] w-[100%]">
                                    {allChat.map((item, index) => {
                                        return <li key={index} className={`${item.senderId === Userid ? "msg_out" : "msg_in"} mt-[15px]`}>
                                            <div style={{ textAlign: item?.senderId === Userid ? "end" : "start" }}>
                                                <span className="msg_text max-_430_:text-[12px]">{item?.content}</span>
                                                <div className="text-[11px] mt-[8px] text-gray-500">{formatTimestamp(item.sentTime)}</div>
                                            </div>
                                        </li>
                                    })}
                                </ul>
                            </div>

                            <div className="bg-white p-[15px] rounded-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <input type="text" value={input} onKeyDown={HandleKeyDown} onChange={(e) => setInput(e.target.value)} className="w-[100%] border-[2px] py-[8px] px-[10px] rounded-[10px] focus-within:outline-gray-400" placeholder={t("Add Message...")} />
                                    <button onClick={HandleSendMessage} className="send_btn">{t("Send")}</button>
                                </div>
                            </div>
                        </div>

                        {loading && <Loading />}

                    </div>}

            </div>
        </div>
    )
}

export default Chat